import axios, { AxiosError, AxiosInstance } from 'axios';
import { RezdyUser } from '../model/RezdyUser';

export class AuthClientSession {
    private readonly client: AxiosInstance;

    constructor(props: { client: AxiosInstance }) {
        this.client = props.client;
        this.client.interceptors.response.use(res => res, this.handleErrorResponse);
    }

    handleErrorResponse = (error: AxiosError) => {
        if (error.response?.status === 401) {
            const url = error.config?.url;
            if (url?.endsWith('/refresh')) {
                return Promise.reject(new Error('USER_NOT_LOGGED_IN'));
            }
            return this.refreshToken().then(() => {
                // retry request if refresh token is successful
                return this.client.request(error.config);
            });
        }
        return Promise.reject(new Error(error.code));
    };

    refreshToken() {
        return this.client.post<void>('/refresh');
    }

    getUserInfo() {
        return this.client.get<RezdyUser>('/userInfo');
    }
}
export function getAuthClientSession(config: { authServer: string }): AuthClientSession {
    const client: AxiosInstance = axios.create({
        baseURL: `${config.authServer}/clientSession`,
        withCredentials: true,
    });
    return new AuthClientSession({
        client,
    });
}
